import httpClient from '../utils/httpClient';

export const eventService = {
    getEvents: async () => {
        const response = await httpClient.get('/event/events');
        return response.data;
    },

    getEventDetail: async (id) => {
        const response = await httpClient.post('/event/event',id);
        return response.data;
    },

    GetDashboardEvent: async () => {
        const response = await httpClient.post('/event/dashboard-event', {});
        return response.data;
    },
}